import { defineStore, storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useWindowSize } from '@vueuse/core';
import { useSystemStore } from '@/modules/core/stores/system.store.ts';
import { Breakpoints } from '@/modules/common/consts/breakpoints.const.ts';
import { StoreId } from '@/modules/common/enums/store-id.enum.ts';

export const useMenuStore = defineStore(StoreId.Menu, () => {
  const { isMenuOpen: isOpen } = storeToRefs(useSystemStore());

  const { width } = useWindowSize();

  const isMobile = computed(() => width.value <= Breakpoints.width.m);
  const isTablet = computed(() => width.value <= Breakpoints.width.l && width.value > Breakpoints.width.m);
  const isCompact = computed(() => isTablet.value || (!isOpen.value && !isMobile.value));

  return { isOpen, isMobile, isTablet, isCompact };
});
